/*import { createContext, useContext, useState } from "react";

const LoadingContext = createContext();

export const useLoading = () => useContext(LoadingContext);

export const LoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <LoadingContext.Provider value={{ isLoading, setIsLoading }}>
      {children}
    </LoadingContext.Provider>
  );
};*/
//this version should only show after a delay and for a min of .5s
import { createContext, useContext, useEffect, useState, useRef } from "react";

const LoadingContext = createContext();

export const useLoading = () => useContext(LoadingContext);

export const LoadingProvider = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false); // real visibility
  const [isLoading, setIsLoading] = useState(false); // logical loading state
  const [suppressLoader, setSuppressLoader] = useState(false); // allow pages to opt out of global loader (chat has own load animation)

  const delayTimer = useRef(null);
  const minDurationTimer = useRef(null);

  useEffect(() => {
    if (suppressLoader) { 
      setIsVisible(false);
      setIsLoading(false);
      return;
    }

    if (isLoading) {
      // Add delay before showing
      delayTimer.current = setTimeout(() => {
        setIsVisible(true);
        // Ensure it stays visible for at least 500ms
        minDurationTimer.current = setTimeout(() => {}, 500);
      }, 200);
    } else {
      // Clear delay if loading stopped quickly
      clearTimeout(delayTimer.current);

      // If loader is visible, wait min duration before hiding
      if (isVisible) {
        clearTimeout(minDurationTimer.current);
        minDurationTimer.current = setTimeout(() => {
          setIsVisible(false);
        }, 300);
      }
    }

    return () => {
      clearTimeout(delayTimer.current);
      clearTimeout(minDurationTimer.current);
    };
  }, [isLoading, suppressLoader]);

  return (
    <LoadingContext.Provider value={{ isLoading, setIsLoading, isVisible, suppressLoader, setSuppressLoader }}>
      {children}
    </LoadingContext.Provider>
  );
};

